import type {
  ExternalTradeSide,
  ExternalTradeStatus,
} from "@/features/portfolio/api/external-trade";

export interface TransactionFilters {
  sides: ExternalTradeSide[];
  statuses: ExternalTradeStatus[];
  startDate: string;
  endDate: string;
}

export const DEFAULT_TRANSACTION_FILTERS: TransactionFilters = {
  sides: [],
  statuses: [],
  startDate: "",
  endDate: "",
};

export const countActiveFilters = (filters: TransactionFilters): number =>
  filters.sides.length +
  filters.statuses.length +
  (filters.startDate ? 1 : 0) +
  (filters.endDate ? 1 : 0);
